let Logs = function () {
  return <div className="fragmentContainer">This is the Logs page</div>;
};

export default Logs;
